import SkillLevelRow from './SkillLevelRow';

export default SkillLevelRow;
